(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["suonama-community"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-community-root]');
    if (!root) return;
    const apiPath = root.dataset.apiPath.replace(/\/$/, '');
    const topics = root.querySelector('[data-community-topics]');
    const connection = root.querySelector('[data-community-connection]');
    const notice = root.querySelector('[data-community-notice]');
    const search = root.querySelector('[data-community-search]');
    const category = root.querySelector('[data-community-category]');
    const sort = root.querySelector('[data-community-sort]');
    const loadMore = root.querySelector('[data-load-more]');
    const toolbar = root.querySelector('.sn-community__toolbar');
    const communityLayout = root.querySelector('.sn-community__layout');
    const layoutSidebar = root.querySelector('.sn-community__sidebar');
    const mainHead = root.querySelector('.sn-community__main-head');
    const detail = root.querySelector('[data-topic-detail]');
    const detailContent = root.querySelector('[data-topic-detail-content]');
    const replies = root.querySelector('[data-topic-replies]');
    const back = root.querySelector('[data-topic-back]');
    const replyForm = root.querySelector('[data-reply-form]');
    const mediaBase = root.dataset.mediaBase.replace(/\/$/, '');
    let cursor = '';
    let activeTopic = '';

    const safe = (value) => {
      const node = document.createElement('span');
      node.textContent = value || '';
      return node.innerHTML;
    };

    const showNotice = (message) => {
      notice.textContent = message;
      notice.hidden = false;
    };

    const authorName = (value) => {
      const name = value || root.dataset.textMember;
      if (root.dataset.customerSuffix && name === `Member ${root.dataset.customerSuffix}`) return root.dataset.customerName || name;
      return name;
    };

    const mediaUrl = (path) => `${mediaBase}/${String(path || '').split('/').map(encodeURIComponent).join('/')}`;

    const formatDate = (value) => {
      const date = new Date(value);
      return Number.isNaN(date.getTime()) ? '' : new Intl.DateTimeFormat(document.documentElement.lang || 'en', { dateStyle: 'medium', timeStyle: 'short' }).format(date);
    };

    const renderTopics = (items, append = false) => {
      if (!append) topics.innerHTML = '';
      if (!items.length && !append) {
        showNotice(root.dataset.textEmpty);
        return;
      }
      items.forEach((topic) => {
        const link = document.createElement('a');
        link.className = 'sn-community__topic';
        const slug = topic.slug || topic.id;
        const pageUrl = new URL(window.location.href);
        pageUrl.searchParams.set('topic', slug);
        link.href = `${pageUrl.pathname}${pageUrl.search}`;
        link.dataset.topicSlug = slug;
        const displayedAuthor = authorName(topic.author_name);
        const initials = displayedAuthor.trim().slice(0, 2).toUpperCase();
        link.innerHTML = `<span class="sn-community__avatar">${safe(initials)}</span><span><span class="sn-community__badge">${safe(topic.category_name)}</span><h3>${safe(topic.title)}</h3><span class="sn-community__topic-meta">${safe(displayedAuthor)} · ${safe(topic.updated_label)}</span></span><span class="sn-community__topic-count">${Number(topic.reply_count || 0)} ${safe(root.dataset.textReplies)}<br>${Number(topic.view_count || 0)} ${safe(root.dataset.textViews)}</span>`;
        link.addEventListener('click', (event) => {
          event.preventDefault();
          openTopicDetail(slug, true);
        });
        topics.appendChild(link);
      });
    };

    const renderAttachments = (items) => {
      if (!Array.isArray(items) || !items.length) return '';
      return `<div class="sn-community__attachments">${items.map((item) => `<a href="${safe(mediaUrl(item.storage_path))}" target="_blank" rel="noopener"><img src="${safe(mediaUrl(item.storage_path))}" alt="${safe(item.file_name || '')}" loading="lazy" width="900" height="675"></a>`).join('')}</div>`;
    };

    const renderReplies = (items) => {
      replies.innerHTML = '';
      if (!Array.isArray(items) || !items.length) {
        replies.innerHTML = `<p class="sn-community__empty-replies">${safe(root.dataset.textEmptyReplies || '')}</p>`;
        return;
      }
      items.forEach((reply) => {
        const displayedAuthor = authorName(reply.community_profiles?.display_name);
        const article = document.createElement('article');
        article.className = 'sn-community__reply';
        article.innerHTML = `<div class="sn-community__reply-head"><span class="sn-community__avatar">${safe(displayedAuthor.trim().slice(0, 2).toUpperCase())}</span><span><span class="sn-community__reply-author">${safe(displayedAuthor)}</span><br><span class="sn-community__reply-date">${safe(formatDate(reply.created_at))}</span></span></div><div class="sn-community__reply-body">${safe(reply.body)}</div>${renderAttachments(reply.community_attachments)}`;
        replies.appendChild(article);
      });
    };

    const showList = (updateHistory = true) => {
      activeTopic = '';
      detail.hidden = true;
      topics.hidden = false;
      toolbar.hidden = false;
      layoutSidebar.hidden = false;
      communityLayout.classList.remove('is-detail');
      mainHead.hidden = false;
      loadMore.hidden = !cursor;
      if (updateHistory) {
        const pageUrl = new URL(window.location.href);
        pageUrl.searchParams.delete('topic');
        window.history.pushState({}, '', `${pageUrl.pathname}${pageUrl.search}${pageUrl.hash}`);
      }
    };

    const openTopicDetail = async (slug, updateHistory = false) => {
      activeTopic = slug;
      topics.hidden = true;
      toolbar.hidden = true;
      layoutSidebar.hidden = true;
      communityLayout.classList.add('is-detail');
      mainHead.hidden = true;
      loadMore.hidden = true;
      detail.hidden = false;
      detailContent.innerHTML = '<div class="sn-community__skeleton"></div>';
      replies.innerHTML = '';
      if (updateHistory) {
        const pageUrl = new URL(window.location.href);
        pageUrl.searchParams.set('topic', slug);
        window.history.pushState({ topic: slug }, '', `${pageUrl.pathname}${pageUrl.search}${pageUrl.hash}`);
      }
      try {
        const response = await fetch(`${apiPath}/api/topics/${encodeURIComponent(slug)}`, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('topic unavailable');
        const data = await response.json();
        const topic = data.topic;
        const displayedAuthor = authorName(topic.community_profiles?.display_name);
        detailContent.innerHTML = `<header class="sn-community__detail-head"><span class="sn-community__badge">${safe(topic.community_categories?.name)}</span><h2>${safe(topic.title)}</h2><div class="sn-community__detail-meta">${safe(displayedAuthor)} · ${safe(formatDate(topic.created_at))} · ${Number(topic.view_count || 0) + 1} ${safe(root.dataset.textViews)}</div></header><div class="sn-community__detail-body">${safe(topic.body)}</div>${renderAttachments(topic.community_attachments)}`;
        renderReplies(topic.community_replies);
        detail.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch (error) {
        detailContent.innerHTML = `<div class="sn-community__notice">${safe(root.dataset.textTopicError)}</div>`;
      }
    };

    const loadTopics = async (append = false) => {
      if (!append) {
        notice.hidden = true;
        topics.innerHTML = '<div class="sn-community__skeleton"></div><div class="sn-community__skeleton"></div><div class="sn-community__skeleton"></div>';
      }
      const params = new URLSearchParams({ q: search.value.trim(), category: category.value, sort: sort.value });
      if (append && cursor) params.set('cursor', cursor);
      try {
        const response = await fetch(`${apiPath}/api/topics?${params}`, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('community unavailable');
        const data = await response.json();
        renderTopics(Array.isArray(data.topics) ? data.topics : [], append);
        cursor = data.next_cursor || '';
        loadMore.hidden = !cursor;
        connection.textContent = data.status_label || 'Online';
        connection.classList.add('is-online');
      } catch (error) {
        if (!append) topics.innerHTML = '';
        connection.textContent = root.dataset.textOffline;
        connection.classList.remove('is-online');
        showNotice(root.dataset.textOffline);
      }
    };

    let timer;
    search.addEventListener('input', () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(() => loadTopics(), 350);
    });
    category.addEventListener('change', () => loadTopics());
    sort.addEventListener('change', () => loadTopics());
    loadMore.addEventListener('click', () => loadTopics(true));
    back.addEventListener('click', () => showList());
    window.addEventListener('popstate', () => {
      const slug = new URL(window.location.href).searchParams.get('topic');
      if (slug) openTopicDetail(slug);
      else showList(false);
    });
    root.querySelectorAll('[data-category-button]').forEach((button) => {
      button.addEventListener('click', () => {
        root.querySelectorAll('[data-category-button]').forEach((item) => item.classList.remove('is-active'));
        button.classList.add('is-active');
        category.value = button.dataset.categoryButton;
        loadTopics();
      });
    });

    const dialog = root.querySelector('[data-topic-dialog]');
    const openTopic = root.querySelector('[data-open-topic]');
    const topicForm = root.querySelector('[data-topic-form]');
    if (dialog && openTopic && topicForm) {
      openTopic.addEventListener('click', () => dialog.showModal());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
      topicForm.addEventListener('submit', async (event) => {
        event.preventDefault();
        const submit = topicForm.querySelector('[data-topic-submit]');
        const status = topicForm.querySelector('[data-form-status]');
        submit.disabled = true;
        status.textContent = root.dataset.textLoading;
        try {
          const response = await fetch(`${apiPath}/api/topics`, { method: 'POST', credentials: 'same-origin', body: new FormData(topicForm), headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('post failed');
          topicForm.reset();
          status.textContent = root.dataset.textPosted;
          window.setTimeout(() => {
            dialog.close();
            status.textContent = '';
            loadTopics();
          }, 900);
        } catch (error) {
          status.textContent = root.dataset.textError;
        } finally {
          submit.disabled = false;
        }
      });
    }

    if (replyForm) {
      replyForm.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (!activeTopic) return;
        const submit = replyForm.querySelector('[data-reply-submit]');
        const status = replyForm.querySelector('[data-reply-status]');
        submit.disabled = true;
        status.textContent = root.dataset.textLoading;
        try {
          const response = await fetch(`${apiPath}/api/topics/${encodeURIComponent(activeTopic)}/replies`, { method: 'POST', credentials: 'same-origin', body: new FormData(replyForm), headers: { Accept: 'application/json' } });
          if (!response.ok) throw new Error('reply failed');
          replyForm.reset();
          status.textContent = root.dataset.textReplyPosted;
          await openTopicDetail(activeTopic);
        } catch (error) {
          status.textContent = root.dataset.textReplyError;
        } finally {
          submit.disabled = false;
        }
      });
    }

    loadTopics();
    const initialTopic = new URL(window.location.href).searchParams.get('topic');
    if (initialTopic) openTopicDetail(initialTopic);
  })();

  } catch(e) { console.error(e); }
})();
})();
